import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { Tooltip } from 'react-leaflet';

const MapLeafletTransportParkingTooltip = (props) => {
  const { value, ...rest } = props;

  return (
    <Tooltip direction='top' className='leaflet-tooltip-top-transport-parking' {...rest}>
      <Stack
        direction='column'
        sx={(theme) => ({
          fontSize: '12px',
          bgcolor: 'background.paper',
          overflow: 'hidden',
          borderRadius: theme.shape.borderRadius,
          minWidth: '220px',
        })}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={(theme) => ({
            padding: theme.spacing(0),
            bgcolor: 'background.default',
            minHeight: '44px',
            '.MuiTypography-root': {
              whiteSpace: 'nowrap',
              margin: theme.spacing(0),
              width: '100%',
              padding: theme.spacing(0),
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              fontSize: '13px',
            },
          })}>
          <Stack
            direction='row'
            sx={{
              flexDirection: 'column',
            }}>
            <Typography variant='body1'>{value.name}</Typography>
            <Typography
              variant='body1'
              sx={{
                fontSize: '11px !important',
              }}>
              Стоянка
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction='row'
          sx={(theme) => ({
            display: 'grid',
            gap: 2,
            padding: theme.spacing(2),
            '.MuiPaper-root': {
              position: 'relative',
              border: 'none',
            },
            '.MuiPaper-row': {
              display: 'grid',
              gap: 1,
              gridTemplateColumns: 'repeat(5, 1fr)',
              '.MuiTypography-root:first-of-type': {
                color: 'text.secondary',
              },
            },
            '.MuiPaper-row .MuiTypography-root:first-of-type': {
              gridRow: '1',
              gridColumn: '1/3',
            },
            '.MuiPaper-row .MuiTypography-root:last-of-type': {
              gridRow: '1',
              gridColumn: '3/6',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              'span:nth-of-type(2)': {
                paddingLeft: theme.spacing(0.5),
              },
            },
          })}>
          <Paper variant='outlined'>
            <Stack className='MuiPaper-row'>
              <Typography variant='body1'>Время:</Typography>
              <Typography variant='body1'>{value.parking_time_start}</Typography>
            </Stack>
            {value.interval && (
              <Stack className='MuiPaper-row'>
                <Typography variant='body1'>Интервал:</Typography>
                <Typography variant='body1'>{value.interval}</Typography>
              </Stack>
            )}
          </Paper>
        </Stack>
      </Stack>
    </Tooltip>
  );
};

export default MapLeafletTransportParkingTooltip;
